import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { VaultDatePipe } from '@shared/pipes/vault-date.pipe';
import { CharterHistoryRow } from '@features/dashboard/company/corporate-charter/corporate-charter-provenance.util';
import { CharterProvenanceComponent } from '@features/dashboard/company/corporate-charter/components/charter-provenance/charter-provenance.component';

/**
 * Linha do tempo dos valores anteriores de um sócio, administrador ou do capital, do mais antigo ao mais recente
 * (ex.: 40% no contrato de 2019, 60% na alteração de 2022, saiu em 2024). Cada linha traz a procedência, que abre o
 * documento na página. A linha do ato vigente (`currentActId`) ganha o selo "vigente".
 */
@Component({
  selector: 'app-charter-history-list',
  imports: [VaultDatePipe, CharterProvenanceComponent],
  template: `
    @if (rows().length === 0) {
      <p class="empty">Sem valores anteriores nos atos lidos.</p>
    } @else {
      <ol class="history" [attr.aria-label]="label()">
        @for (row of rows(); track $index) {
          <li class="history__item" [class]="'history__item history__item--' + row.tone">
            <span class="history__dot" aria-hidden="true"></span>
            <div class="history__body">
              <div class="history__line">
                <strong class="history__act">{{ row.provenance.actLabel || 'Ato' }}</strong>
                @if (row.provenance.actDate) {
                  <span class="history__date">{{ row.provenance.actDate | vaultDate }}</span>
                }
                <span class="history__event">{{ row.eventLabel }}</span>
                @if (
                  currentActId() && row.tone === 'listed' && row.provenance.actId === currentActId()
                ) {
                  <span class="history__current">vigente</span>
                }
              </div>
              @if (row.values) {
                <span class="history__values">{{ row.values }}</span>
              }
              @if (row.summary) {
                <span class="history__summary">{{ row.summary }}</span>
              }
              <app-charter-provenance [from]="row.provenance" />
            </div>
          </li>
        }
      </ol>
    }
  `,
  styleUrl: './charter-history-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CharterHistoryListComponent {
  readonly rows = input<CharterHistoryRow[]>([]);
  /** Rótulo acessível ("Histórico de Maria Souza"). */
  readonly label = input('Histórico');
  /** Ato de onde vem o valor vigente: a linha desse ato ganha o selo "vigente" (nulo para ex-sócios). */
  readonly currentActId = input<string | null | undefined>(null);
}
